import type { DemoPill } from './colimind-types';
import { TREND_PILLS } from './demo-responses-trend';
import { KPI_PILLS } from './demo-responses-kpi';

export const DEMO_PILLS: DemoPill[] = [...TREND_PILLS, ...KPI_PILLS];
